import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import { cloneDeep } from "lodash";
import MicroModal from "micromodal";
import Switch from "react-switch";
import { People } from "iconsax-reactjs";

import Table from "../../../../components/table";
import InputSearch from "../../../InputSearch/InputSearch";
import Checkbox from "../../../manager-section/CheckboxIng/CheckboxIng";
import FieldContainer from "../../../FieldContainer/FieldContainer";
import Typography from "../../../Typography";
import { Popover } from "../../../../actions/Tippy";
import Paperplane from "../../../Loading/Paperplane";

import * as APIDashboard from "../../../../services/nps/functions";

import { ReactComponent as HamburgerIcon } from "../../../../build/images/icons/hamburger.svg";
import { ReactComponent as LayersClearIcon } from "../../../../build/images/nps-dashboard-icons/layers_clear.svg";
import { ReactComponent as CommunitiesIcon } from "../../../../build/images/nps-dashboard-icons/communities.svg";
import { ReactComponent as DayWeekIcon } from "../../../../build/images/nps-dashboard-icons/day-week.svg";
import { ReactComponent as DomainIcon } from "../../../../build/images/nps-dashboard-icons/domain.svg";
import { ReactComponent as EmptyState } from "../../../../build/images/emptystatemanagerhorizontal.svg";

import "./negotiations.css";

export default function Negotiations() {
  const filtersDashboard = useSelector((state) => state.npsfilters);
  const InfoUsers = useSelector((state) => state.informationusers);

  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [dataTable, setDataTable] = useState([]);
  const [dataTotal, setDataTotal] = useState([]);
  const [agroupSelected, setAgroupSelected] = useState([]);
  const [desagroupSelected, setDesagroupSelected] = useState([]);
  const [unitysSelected, setUnitysSelected] = useState([]);
  const [typeAgroup, setTypeAgroup] = useState(0);
  const [nameGroup, setNameGroup] = useState("");
  const [searchData, setSearchData] = useState("");
  const [typeGroup, setTypeGroup] = useState("group");
  const [dispareFilter, setDispareFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  let columns = [];

  async function getUnityList() {
    setLoading(true);
    let response;

    if (typeGroup === "group") {
      response = await APIDashboard.getUnityList(
        format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
        format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
        filtersDashboard.business.map((option) => option.id).join(),
        filtersDashboard.units.map((option) => option.id).join(),
        InfoUsers.id,
        filtersDashboard.questionsNPS.map((option) => option.id).join(),
        filtersDashboard.questionsCSAT.map((option) => option.id).join(),
        filtersDashboard.channels.map((option) => option.id).join(),
      );
    } else {
      response = await APIDashboard.getUnityListUngrouped(
        format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
        format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
        filtersDashboard.business.map((option) => option.id).join(),
        filtersDashboard.units.map((option) => option.id).join(),
        InfoUsers.id,
        filtersDashboard.questionsNPS.map((option) => option.id).join(),
        filtersDashboard.questionsCSAT.map((option) => option.id).join(),
        filtersDashboard.channels.map((option) => option.id).join(),
      );
    }

    if (response && response.status === 200) {
      const data = response.data;
      //   const unidades = [{ idunidade: 11, descunidade: "CMO" }];
      // data.push({
      //   unidade: "TESTE2",
      //   idunidade: 5,
      //   nps: "50",
      //   detratores: 2,
      //   percentual_tratados: 25,
      //   tempo_medio: 2.5,
      //   unidades: "[]",
      // });
      // data.push({
      //   unidade: "TESTE3",
      //   idunidade: 7,
      //   nps: "70",
      //   detratores: 15,
      //   percentual_tratados: 5,
      //   tempo_medio: 1,
      //   unidades: "[]",
      // });

      setDataTotal(data);
      setDataTable(data);
      setDispareFilter(true);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
    setLoading(false);
  }

  async function agroupUnits() {
    if (agroupSelected.length) {
      //InfoUsers.id
      const response = await APIDashboard.insertNameUnitGroup(
        nameGroup,
        InfoUsers.id,
      );

      if (response && response.status === 200) {
        const data = response.data;

        if (data.length) {
          let totalFeito = 0;
          const createGroup = agroupSelected.map(async (unity) => {
            const responseUnity = await APIDashboard.insertUnitGroup(
              data[0].id,
              unity,
            );

            if (responseUnity.status === 200) {
              const dataUnity = responseUnity.data;

              return (totalFeito = totalFeito + 1);
            } else {
              console.log(
                "Falha, não foi possível carregar as informações!",
                "Verifique sua conexão e tente novamente mais tarde.",
              );
            }
          });

          await Promise.all(createGroup);

          if (totalFeito === agroupSelected.length) {
            document
              .querySelectorAll('input.checkboxNps[type="checkbox"]')
              .forEach((datum) => {
                return datum.checked ? (datum.checked = false) : "";
              });
            setAgroupSelected([]);
            setDesagroupSelected([]);
            setNameGroup("");
            await getUnityList();
            MicroModal.close("modal__tabelGroup");
          }
        }
      } else {
        console.log(
          "Falha, não foi possível carregar as informações!",
          "Verifique sua conexão e tente novamente mais tarde.",
        );
      }
    }
  }

  async function desagroupUnits() {
    if (desagroupSelected.length) {
      const idGroup = desagroupSelected[0];
      const unidades = unitysSelected;
      let totalDesfeito = 0;

      let deleteUnits = unidades.map(async (unidade) => {
        //InfoUsers.id
        const response = await APIDashboard.deleteUnitGroup(
          idGroup,
          unidade.idunidade,
          InfoUsers.id,
        );

        if (response && response.status === 200) {
          return (totalDesfeito = totalDesfeito + 1);
        } else {
          console.log(
            "Falha, não foi possível carregar as informações!",
            "Verifique sua conexão e tente novamente mais tarde.",
          );
        }
      });

      await Promise.all(deleteUnits);

      if (totalDesfeito === unidades.length) {
        //InfoUsers.id
        const response = await APIDashboard.deleteNameUnitGroup(
          idGroup,
          InfoUsers.id,
        );
        if (response && response.status === 200) {
          document
            .querySelectorAll('input.checkboxNps[type="checkbox"]')
            .forEach((datum) => {
              return datum.checked ? (datum.checked = false) : "";
            });
          setAgroupSelected([]);
          setDesagroupSelected([]);
          await getUnityList();
          MicroModal.close("modal__tabelGroup");
        } else {
          console.log(
            "Falha, não foi possível carregar as informações!",
            "Verifique sua conexão e tente novamente mais tarde.",
          );
        }
      }
    }
  }

  function refactorNpsList(data) {
    let dataRefactored = [];

    data.forEach((datum) => {
      const unidades = datum.unidades ? JSON.parse(datum.unidades) : [];

      const caseRefactored = {
        select: {
          data: (
            <div className="units-info">
              {unidades.length ? (
                <Checkbox
                  onChange={(event) => {
                    setTypeAgroup(1);
                    changeDesagroupUnits(event, unidades);
                  }}
                  typeCheck="checkbox"
                  name={"checkboxNps" + datum.unidade}
                  className="checkboxNps"
                  id={datum.idunidade}
                  value={datum.idunidade}
                  checked={desagroupSelected.includes(datum.idunidade)}
                  disabled={
                    (desagroupSelected.length > 0 &&
                      !desagroupSelected.includes(datum.idunidade)) ||
                    agroupSelected.length > 0
                      ? true
                      : false
                  }
                />
              ) : (
                <Checkbox
                  onChange={(event) => {
                    setTypeAgroup(0);
                    changeAgroupUnits(event);
                  }}
                  typeCheck="checkbox"
                  className="checkboxNps"
                  name={"checkboxNps" + datum.unidade}
                  id={datum.idunidade}
                  value={datum.idunidade}
                  checked={agroupSelected.includes(datum.idunidade)}
                  disabled={desagroupSelected.length > 0}
                />
              )}
              {unidades.length > 0 ? (
                <Popover
                  theme="ingweb nps-table"
                  content={renderContent(2, unidades)}
                >
                  <CommunitiesIcon />
                </Popover>
              ) : (
                ""
              )}
            </div>
          ),
          config: {},
        },
        units: {
          data: datum.unidade,
          config: {
            className: "cell-gray-text",
            textEllipsis: false,
          },
        },
        nps: {
          data: Number(datum.nps),
          config: {
            textEllipsis: true,
            className: "",
          },
        },
        detractors: {
          data: datum.detratores,
          config: {
            className: "",
          },
        },
        treaties: {
          data: datum.percentual_tratados,
          config: {
            className: "",
          },
        },
        averagetime: {
          data: datum.tempo_medio_fechamento
            ? handleTempMed(datum.tempo_medio_fechamento)
            : 0,
          config: {
            className: "",
            textEllipsis: true,
          },
        },
      };

      dataRefactored.push(caseRefactored);
    });

    return dataRefactored;
  }

  /*
  function handleTempMed(tempMed) {
    // ANO | MES | DIA | HORA | MINUTO | SEGUNDO
    const cutTime = tempMed.split("|");
    let ano = cutTime[0];
    let mes = cutTime[1];
    let dia = cutTime[2];
    let hora = cutTime[3];
    let minuto = cutTime[4];
    let segundo = cutTime[5];

    if (ano !== "0000") {
      return `${ano.replaceAll("0", "")} ano(s)`;
    } else if (mes !== "00") {
      const corrigirMeses = mes.replaceAll("0", "");
      return `${mes.replaceAll("0", "")} ${
        corrigirMeses > 1 ? "meses" : "mês"
      }`;
    } else if (dia !== "00") {
      return `${dia.replaceAll("0", "")} dia(s)`;
    } else if (hora !== "00") {
      return `${hora.replaceAll("0", "")} hora(s)`;
    } else if (minuto !== "00") {
      return `${minuto.replaceAll("0", "")} minuto(s)`;
    } else if (segundo !== "00") {
      return `${segundo.replaceAll("0", "")} segundo(s)`;
    }
  }
  */

  function handleTempMed(tempMed) {
    // ANO | MES | DIA | HORA | MINUTO | SEGUNDO
    const cutTime = tempMed.split("|");
    let ano = cutTime[0];
    let mes = cutTime[1];
    let dia = cutTime[2];
    let hora = cutTime[3];
    let minuto = cutTime[4];
    let segundo = cutTime[5];

    if (ano !== "0000") {
      return `${Number(ano)} ano(s)`;
    } else if (mes !== "00") {
      const corrigirMeses = Number(mes);
      return `${Number(mes)} ${corrigirMeses > 1 ? "meses" : "mês"}`;
    } else if (dia !== "00") {
      return `${Number(dia)} dia(s)`;
    } else if (hora !== "00") {
      return `${Number(hora)} hora(s)`;
    } else if (minuto !== "00") {
      return `${Number(minuto)} minuto(s)`;
    } else if (segundo !== "00") {
      return `${Number(segundo)} segundo(s)`;
    }
  }

  const changeAgroupUnits = (e) => {
    const { id, checked } = e.target;

    // Se o checkbox foi marcado, adiciona o ID à array
    // Se o checkbox foi desmarcado, remove o ID da array
    setAgroupSelected((prevIds) =>
      checked
        ? [...prevIds, Number(id)]
        : prevIds.filter((item) => item !== Number(id)),
    );
  };

  const changeDesagroupUnits = (e, unitys) => {
    const { id, checked } = e.target;

    // Se o checkbox foi marcado, adiciona o ID à array
    // Se o checkbox foi desmarcado, remove o ID da array
    setDesagroupSelected((prevIds) => (checked ? [Number(id)] : []));
    setUnitysSelected((prevIds) => (checked ? unitys : []));
  };

  function defaultSorting(rowA, rowB, columnId) {
    const objectRowA = rowA.original[columnId].data.toLowerCase();
    const objectRowB = rowB.original[columnId].data.toLowerCase();

    if (objectRowA > objectRowB) return -1;
    if (objectRowB > objectRowA) return 1;

    return 0;
  }

  function numberSorting(rowA, rowB, columnId) {
    const objectRowA = rowA.original[columnId].data;
    const objectRowB = rowB.original[columnId].data;

    if (objectRowA > objectRowB) return -1;
    if (objectRowB > objectRowA) return 1;

    return 0;
  }

  const renderContent = (type, data) => {
    if (type === 1) {
      return (
        <ul className="content-popover">
          <li
            className={typeGroup === "group" ? "active" : ""}
            onClick={() => setTypeGroup("group")}
          >
            <Typography.H5>Visualizar trativas no modo agrupado</Typography.H5>
          </li>
          <li
            className={typeGroup === "ungroup" ? "active" : ""}
            onClick={() => setTypeGroup("ungroup")}
          >
            <Typography.H5>
              Visualizar trativas no modo desagrupado
            </Typography.H5>
          </li>
        </ul>
      );
    } else {
      return (
        <div className="units-popover">
          <div className="units-popover__title">
            <DomainIcon />
            <Typography.H5 weight={700} color={"white"}>
              Unidades
            </Typography.H5>
          </div>
          <ul>
            {data.map((datum) => (
              <li key={datum.idunidade}>
                <Typography.H6 color={"white"}>
                  {datum.descunidade}
                </Typography.H6>
              </li>
            ))}
          </ul>
        </div>
      );
    }
  };

  function handleSearch(value) {
    const newData = dataTotal.filter((datum) => {
      const avaliaTempoMedio = datum.tempo_medio_fechamento
        ? handleTempMed(datum.tempo_medio_fechamento)
        : 0;

      if (
        datum.unidade.toLowerCase().includes(value.toLowerCase()) ||
        datum.nps.toString().includes(value) ||
        datum.detratores.toString().includes(value) ||
        datum.percentual_tratados.toString().includes(value) ||
        avaliaTempoMedio.toString().includes(value)
      ) {
        return true;
      }
    });

    setDataTable(newData);
  }

  const npsDatas = useMemo(() => {
    if (dataTable) {
      const dataRefactored = refactorNpsList(dataTable);
      //   setPageStatus("awaiting");
      return dataRefactored;
    }
  }, [dataTable, agroupSelected, desagroupSelected, typeAgroup]);

  columns = useMemo(
    () => [
      {
        Header: ({ table }) => (
          <Checkbox
            // typeCheck="checkbox"
            className="checkboxNps-header"
            name={"checkboxNps-header"}
            id={"header-1"}
            // value={datum.idunidade}
            checked={agroupSelected.length + desagroupSelected.length}
            readOnly
          />
        ),
        accessor: "select",
        id: "select",
        disableFilters: true,
        disableSortBy: true,
        // sortType: defaultSorting,
        display: true,
      },
      {
        Header: "Unidades",
        accessor: "units",
        id: "units",
        disableFilters: true,
        sortType: defaultSorting,
        display: true,
      },
      {
        Header: "NPS",
        accessor: "nps",
        id: "nps",
        sortType: numberSorting,
        disableFilters: true,
        display: true,
      },
      {
        Header: "Detratores",
        accessor: "detractors",
        id: "detractors",
        disableFilters: true,
        sortType: numberSorting,
        display: true,
      },
      {
        Header: "% de tratados",
        accessor: "treaties",
        id: "treaties",
        disableFilters: true,
        sortType: numberSorting,
        display: true,
      },
      {
        Header: "Tempo médio",
        accessor: "averagetime",
        id: "averagetime",
        disableFilters: true,
        sortType: numberSorting,
        display: true,
      },
    ],
    [dataTable, agroupSelected, desagroupSelected, typeAgroup],
  );
  // columns = [
  //   {
  //     Header: ({ table }) => (
  //       // <input
  //       //   type="checkbox"
  //       //   // ref={ref}
  //       //   // className={className + ' cursor-pointer'}
  //       //   checked={agroupSelected.length + desagroupSelected.length}
  //       //   // {...rest}
  //       // />
  //       <Checkbox
  //         typeCheck="checkbox"
  //         className="checkboxNps-header"
  //         name={"checkboxNps-header"}
  //         id={"header-1"}
  //         // value={datum.idunidade}
  //         checked={agroupSelected.length + desagroupSelected.length}
  //       />
  //     ),
  //     accessor: "select",
  //     id: "select",
  //     disableFilters: true,
  //     disableSortBy: true,
  //     // sortType: defaultSorting,
  //     display: true,
  //   },
  //   {
  //     Header: "Unidades",
  //     accessor: "units",
  //     id: "units",
  //     disableFilters: true,
  //     sortType: defaultSorting,
  //     display: true,
  //   },
  //   {
  //     Header: "NPS",
  //     accessor: "nps",
  //     id: "nps",
  //     sortType: numberSorting,
  //     disableFilters: true,
  //     display: true,
  //   },
  //   {
  //     Header: "Detratores",
  //     accessor: "detractors",
  //     id: "detractors",
  //     disableFilters: true,
  //     sortType: numberSorting,
  //     display: true,
  //   },
  //   {
  //     Header: "% de tratados",
  //     accessor: "treaties",
  //     id: "treaties",
  //     disableFilters: true,
  //     sortType: numberSorting,
  //     display: true,
  //   },
  //   {
  //     Header: "Tempo médio",
  //     accessor: "averagetime",
  //     id: "averagetime",
  //     disableFilters: true,
  //     sortType: numberSorting,
  //     display: true,
  //   },
  // ];

  useEffect(() => {
    getUnityList();
    setDispareFilter(true);
  }, []);

  useEffect(() => {
    if (filtersDashboard.active && dispareFilter) {
      getUnityList();
    }
  }, [filtersDashboard]);

  useEffect(() => {
    if (dispareFilter) {
      getUnityList();
    }
  }, [typeGroup]);

  useEffect(() => {
    if (!searchData) {
      setDataTable(dataTotal);
    }
  }, [searchData]);

  useEffect(() => {
    setDataTable(dataTotal);
  }, [agroupSelected, desagroupSelected]);

  return (
    <section className="negotiations-quality">
      <div className="negotiations-card">
        <header className="negotiations-card-header">
          <div className="cards-headers">
            <h4>Trativas por unidades</h4>
          </div>
          <div className="negotiations-card-header__content">
            <div className="negotiations-card-header__content__input">
              <InputSearch
                search={searchData}
                setSearch={setSearchData}
                // handleClick={(e) => handleSearch(searchData)}
                onSearch={(e) => handleSearch(searchData)}
                onKeyDown={true}
              />
            </div>

            <div className="negotiations-card-header__content__switch">
              <Switch
                id={"agroup-switch"}
                checked={typeGroup === "group"}
                onChange={() =>
                  setTypeGroup(typeGroup === "group" ? "ungroup" : "group")
                }
                uncheckedIcon={false}
                checkedIcon={false}
                onColor={"#b8c1ea"}
                onHandleColor={"#455CC7"}
                offColor={"#E5EAF9"}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                width={32}
                height={20}
                handleDiameter={12}
              />

              <span className="negotiations-card-header__content__switch-text">
                Visualizar tratativas no modo agrupado
                {/* {typeGroup === "group" ? "agrupado" : "desagrupado"} */}
              </span>

              {/* <Popover trigger={"click"} content={renderContent(1)}>
                <HamburgerIcon />
              </Popover> */}
            </div>

            {typeGroup !== "ungroup" && (
              <button
                className={`ungrouping-units ${
                  agroupSelected.length > 1 || desagroupSelected.length
                    ? ""
                    : "disable"
                }
              `}
                onClick={() => MicroModal.show("modal__tabelGroup")}
              >
                <People variant="Outline" size={16} />

                <h6>
                  {typeAgroup === 0
                    ? "Agrupar unidades"
                    : "Desagrupar unidades"}
                </h6>
              </button>
            )}
          </div>
        </header>

        <div className="trading-table-container">
          {loading ? (
            <Paperplane />
          ) : npsDatas.length ? (
            <Table
              className="table-cases"
              data={npsDatas}
              columns={columns}
              fixedHeader
              // fixedFirstColumn
              // filtersActive={filtersActive}
              // emptyState={emptyState}
              // setEmptyState={setEmptyState}
              // initialState={sortBy}
              // screen="manager_operators"
              screen="npsTables"
            />
          ) : (
            <div className="card-table__area-empty">
              <EmptyState />
            </div>
          )}
        </div>
      </div>
      {/* Modal de Vincular/Adicionar Contato */}
      <div
        className="modal micromodal-slide"
        id="modal__tabelGroup"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__tabelGroup__title"
          >
            <header className="modal__header">
              <Typography.H1 color={"blue-selected-4"} weight={700}>
                {typeAgroup === 0 ? "Agrupar unidades" : "Desagrupar unidades"}
              </Typography.H1>
              <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
                onClick={(e) => MicroModal.close("modal__tabelGroup")}
              ></button>
            </header>
            <main className="modal__content" id="modal__tabelGroup__content">
              <>
                <Typography.H4 color={"gray-180"}>
                  {typeAgroup === 0
                    ? "Ao agrupar as unidades, todos os indicadores serão unificados e reajustados de acordo com a mediana."
                    : "Ao desagrupar as unidades, todos os indicadores serão separados e reajustados."}
                </Typography.H4>

                {typeAgroup === 0 && (
                  <FieldContainer title="Descrição" htmlFor="">
                    <input
                      type="text"
                      value={nameGroup}
                      //   placeholder="Busca..."
                      onChange={(event) => {
                        setNameGroup(event.target.value);
                      }}
                    />
                    <span>Permitido no máximo 50 caracteres</span>
                  </FieldContainer>
                )}
              </>
            </main>
            <div className="modal-box__footer">
              <button
                className={`button_cancel ${
                  typeAgroup === 1 ? "desagroup-button" : ""
                }`}
                onClick={(e) => MicroModal.close("modal__tabelGroup")}
              >
                <span>Cancelar</span>
              </button>
              <button
                className={`button_save ${
                  typeAgroup === 1 ? "desagroup-button" : ""
                }`}
                onClick={(e) => {
                  if (typeAgroup === 1) {
                    desagroupUnits();
                  } else {
                    agroupUnits();
                  }
                }}
              >
                <span>{typeAgroup === 1 ? "Desagrupar" : "Salvar"}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Fim do Modal de Vincular/Adicionar Contato */}
    </section>
  );
}
